import { useState, useEffect } from 'react';
import authService from '../../services/authService';

export const useAppAuth = () => {
  const [user, setUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initializeAuth = async () => {
      setLoading(true);
      try {
        const user = await authService.initializeAuth();
        if (user) {
          setUser(user);
          setUserProfile(user);
        } else {
          setUser(null);
          setUserProfile(null);
        }
      } catch (error) {
        console.error('Auth initialization error:', error);
        setUser(null);
        setUserProfile(null);
      } finally {
        setLoading(false);
      }
    };

    // Set up auth state listener
    const unsubscribe = authService.onAuthStateChanged(async (user) => {
      if (user) {
        setUser(user);
        setUserProfile(user);
      } else {
        setUser(null);
        setUserProfile(null);
        setLoading(false);
      }
    });

    initializeAuth();

    return () => unsubscribe();
  }, []);

  const handleLogin = (user) => {
    setUser(user);
    setUserProfile(user);
    // loadData is handled by onAuthStateChanged
  };

  const handleLogout = async () => {
    try {
      // Clear admin session on explicit logout (user clicked Sign Out)
      await authService.logout(true);
      setUser(null);
      setUserProfile(null);
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return {
    user,
    userProfile,
    loading,
    handleLogin,
    handleLogout
  };
};